// rating-criterias.js
import { ratingCriterias as schema } from 'store/common/schemas';
import { createEntitiesReducer, createEntitiesSelector } from './helpers';

export const reducer = createEntitiesReducer(schema);

export const selector = createEntitiesSelector(schema);



// WEBPACK FOOTER //
// ./src/store/entities/rating-criterias.js